import {CellValueBoolDefaultBox} from './cell-value-bool.default.box';

export  const CellValueBoolBox = CellValueBoolDefaultBox;